<div class="appointments__header">{{ day | date:'d. M. y' }}</div>
<div *ngIf="appointments">
  <ng-container *ngFor="let appointment of appointments">
    <button class="appointments__appointment"
      [ngClass]="{'appointments__appointment--booked': appointment.isBooked, 'appointments__appointment--disabled': appointment.isDisabled, 'appointments__appointment--cancelled': appointment.isCancelled }"
      [routerLink]="{ outlets: { modal: [day.format('Y-MM-DD'), appointment.value, calendar.minute_interval] } }">
      {{ appointment.value }}
    </button>
  </ng-container>
</div>
<div *ngIf="!appointments || appointments.length === 0" class="appointments__nodata">
  <swb-no-data text="Na tento den nejsou naplánovány žádné volné termíny."></swb-no-data>
</div>
